import React, { useState } from 'react'

interface Props {
  src?: string; // base64 image string
  title?: string;
}

const ZoomableImage = (props: Props) => {
  const [isZoomed, setIsZoomed] = useState<Boolean>(false)
  const toggleZoom = () => {
    setIsZoomed(!isZoomed)
  }
  const getTitleElement = (title?: string) => {
  if (title) {
    return <div className="zoomableImageTitle">
      <span>{title}</span>
      <button className="button" onClick={toggleZoom}>Schließen</button>
    </div>
  }
}
  if (isZoomed) {
    return <div id="backdrop" className="backdrop">
      {getTitleElement(props.title)}
      <img className="measurement-image-previev" src={props.src} onClick={toggleZoom} alt="Foto zu dieser Messung"/>
    </div>
  } else {
    return <img className="measurement-image-small" src={props.src} onClick={toggleZoom} alt="Foto zu dieser Messung"/>
  }
}

export default ZoomableImage
